import { useQuery } from "@tanstack/react-query";
import { GachaPrize } from "@/lib/models/gacha_prize";
import { transformGachaPrizeToOffer } from "@/lib/util";

export function useFetchGachaOffers(
  appId: string,
  accessToken: string | null,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ["gachaOffers", appId],
    enabled: options?.enabled !== false && !!appId && !!accessToken,
    queryFn: async () => {
      if (!appId) throw new Error("App ID is required");
      if (!accessToken) throw new Error("Access token is required");

      const gachaApiUrl = process.env.NEXT_PUBLIC_GACHA_API_URL;

      if (!gachaApiUrl) {
        throw new Error("NEXT_PUBLIC_GACHA_API_URL is not configured");
      }

      // Encode app_id: BASE64 then URL encode
      //const base64EncodedAppId = Buffer.from(appId).toString("base64");
      const urlEncodedAppId = encodeURIComponent(
        "OdvHehHjImxxoWWasHG4mUfsZZ/mZUYpUnKHPAgc/Ik=",
      );

      const response = await fetch(`${gachaApiUrl}api/app/welcia/user/prize`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Ocp-Apim-Subscription-Key":
            process.env.NEXT_PUBLIC_SUBSCRIPTION_KEY || "",
          Authorization: `Bearer ${accessToken}`,
        },
        body: `app_id=${urlEncodedAppId}`,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch gacha offers: ${response.statusText}`);
      }

      const data = await response.json();
      const prizes = (data?.userPrizes || data || []) as GachaPrize[];

      return prizes.map(transformGachaPrizeToOffer);
    },
  });
}
